import { NgModule } from '@angular/core';
import { TextEllipsisToTooltipDirective } from './text-ellipsis-to-tooltip.directive';
import { HotjarSuppressDirective } from './hotjar-suppress.directive';

@NgModule({
  declarations: [TextEllipsisToTooltipDirective, HotjarSuppressDirective],
  exports: [TextEllipsisToTooltipDirective, HotjarSuppressDirective],
})
export class DirectivesModule {}
